module.exports = {

chilliz : "6C9AEE37-BC05-4FB8-A351-D51458B83F26",
leanbento : "F77D467A-F552-4BB3-ABBF-C491DB6661A0",
demo : "500B0232-1BEB-4A9A-92C4-F466638AE496",
vantase : "8F8FE4E6-88C9-4071-9215-312E0F50016A",
bushido : "AD8BDEE2-92AA-461A-AEAF-47E921C99235",
workspace : "56E9AF98-4562-4AB8-95D8-3BDB4423A9E4",
zazzpizza : "DDAA254C-BD1E-49F0-AD1E-164A140421D3"
     
};



// WEBPACK FOOTER //
// ./src/apps.js